import { type FC } from "react";
import Parameter from "../../../../common/components/Parameter";
import Tracker from "../../../../common/components/Tracker";
import { type WeightData } from "../../../../models/WeightData";
import { WeightFormat } from "../../../../common/components/formatting/WeightFormat";
import { type InvoiceInfoData } from "../../../common/models";
import { useTranslation } from "react-i18next";

interface PackageTableRowProps {
  packageIndex: number;
  totalPackageCount: number;
  packageId: string;
  invoiceInfoData?: InvoiceInfoData;
  weightData: WeightData;
  validHandlingUnit: boolean;
}

const ShipmentPackageInformation: FC<PackageTableRowProps> = ({
  packageIndex,
  totalPackageCount,
  packageId,
  invoiceInfoData,
  weightData,
  validHandlingUnit,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Parameter label={t("cartPage.shipmentDetails.table.header.packageNumber")}>
        {t("cartPage.shipmentDetails.table.header.packageNumberValues", {
          index: packageIndex + 1,
          totalCount: totalPackageCount,
        })}
      </Parameter>
      <Parameter label={t("cartPage.shipmentDetails.table.header.packageId")} className={"mt-2"}>
        {validHandlingUnit ? parseInt(packageId) : t("orderDetailsPage.shipmentDetails.pending")}
      </Parameter>
      {invoiceInfoData && (
        <Parameter label={t("quoteDetailsPage.summary.shipmentReference")} className={"mt-2"}>
          <Tracker data={invoiceInfoData} />
        </Parameter>
      )}
      <Parameter label={t("cartPage.shipmentDetails.table.header.packageWeight")} className={"mt-2"}>
        <WeightFormat weight={weightData} />
      </Parameter>
    </>
  );
};

export default ShipmentPackageInformation;
